import { StateCreator } from 'zustand';
import { VariableWithValue } from '../../data/interfaces/Document';
import { storeResetFns } from '.';

type State = {
	variables: VariableWithValue[];
};

type Actions = {
	setVariables: (value: VariableWithValue[]) => void;
	updateVariable: (id: string, data: any) => void;
};

export type VariablesState = State & Actions;

const initialState = {
	variables: null,
};

export const createVariablesSlice: StateCreator<VariablesState> = (set, get) => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setVariables: value => {
			set({
				variables: value,
			});
		},
		updateVariable: (
			id: string,
			data: Partial<VariableWithValue> | VariableWithValue
		) => {
			const { variables } = get();
			const updateItem = item => {
				if (data) {
					item = { ...item, value: data };
				} else {
					delete item.value;
				}
				return item;
			};

			set({
				variables: variables.map(item => {
					return item.id === id ? updateItem(item) : item;
				}),
			});
		},
	};
};
